<template>
 <div class="resource-grid">
   <div class="file-grid-top-panel">
     <label class="el-checkbox" @click.stop="toggleSelectAll" style="margin-left:5px;margin-right: 25px"><span ref="gridSelectAllInput" :class="'el-checkbox__input'+ ((fileData.length > 0 && multipleSelectionIds.length == fileData.length) ? ' is-checked' : '')"><span class="el-checkbox__inner"></span></span></label>
     <span v-if="multipleSelectionIds.length > 0">已选中{{multipleSelectionIds.length}}个文件/文件夹</span><span v-else>全选</span>
     <el-divider></el-divider>
   </div>
   <div class="file-grid-panel" :style="'height:'+tableHeight+'px'" v-show="fileData.length > 0">
    <div :class="'file-grid-item'+ (row.checked == true ? ' selected' : '')" @click.stop="toggleClickGrid(row)" v-for="(row,index) in fileData" :key="row.id" :rowIndex="index"
         @contextmenu="showMenu(row, index)">
      <span :class="'el-radio__input'+ (row.checked == true ? ' is-checked' : '')"><span class="el-radio__inner"></span></span>
      <div class="file-grid-item-inner">
        <div @click.stop="gotoDir(row)" :class="'file-grid-item-img ' + (row.isDir == 1 ? ' folder' : '')" :style="generateRowImgStyle(row)">
          <span :class="'file-grid-item-icon-panel ' + (row.thumbState == 1 ? 'tag' : 'normal')" v-html="fmtFileIcon(row)" v-if="row.isDir != 1"></span>
        </div>
        <span v-if="row.id == editCellId">
          <el-tooltip :popper-class="editCellErrorTip != '' ? '' : ' no-error-tip'" :content="editCellErrorTip"  placement="bottom" effect="light" :hide-after="0"	:v-model="editCellToolTipVisible">
            <input :ref="'editGridCell'+(row.id != null ? row.id : index)" class="edit-cell" v-model="editCellVal" @click.stop @input="handleCellInput($event)" @keydown="handleCellInputKeyDown($event, index, row)" @focus="handleCellInputFocus($event)" @blur="handleCellInputBlur($event, index, row)" maxlength="198" />
          </el-tooltip>
           <el-button class="custom-icon-button cancel-edit-mode" icon="iconfont icon-close" @click.stop.native="cancelEditMode" style="margin-left: 5px;display:none;vertical-align: middle;" title="退出编辑"></el-button>
        </span>
        <div @click.stop="gotoDir(row)" class="file-grid-item-label" :title="fmtFileFullName(row)" v-else><span v-text="fmtFileFullName(row)"></span></div>
      </div>
    </div>
   </div>
   <div class="el-table__empty-block" v-if="fileData.length == 0">
     <span class="el-table__empty-text">
        <ResourceEmpty @uploadFiles="uploadFiles" @download="download" :queryParamsKey="queryParams.key"></ResourceEmpty>
     </span>
   </div>
   <div id="dragBox" style="display: none"></div>
   <vue-context-menu ref="contextMenuGrid" style="width: 106px;background: #fff;margin-left: 0;padding-left: 0"
       :contextMenuData="contextMenuData" @downloadMenuHandler="downloadMenuHandler" @moveMenuHandler="moveMenuHandler"
       @renameMenuHandler="renameMenuHandler" @deleteMenuHandler="deleteMenuHandler">
   </vue-context-menu>
   <ResourceMove ref="resourceMove" :parentId="parentId" :moveForm="moveForm" @refreshFiles="refreshFiles" :backOptDuration="backOptDuration" :notifyMsgCache="notifyMsgCache" @closeAllNotify="closeAllNotify"></ResourceMove>
 </div>
</template>

<script>
import ResourceEmpty from "./ResourceEmpty";
import ResourceMove from "./ResourceMove.vue";
import {fetchFileTypeIcon, fmtFileFullName} from "../../utils/resUtil";
import {fmtInvalidFileName, validateFileName} from "../../../../common-components/src/utils/fileUtil";

const TABLE_OFFSET_TOP = 168 + 40;
const TABLE_MIN_HEIGHT = 150;
function calcTableHeight() {
  return  Math.max(window.innerHeight - TABLE_OFFSET_TOP, TABLE_MIN_HEIGHT);
}
export default {
  name: "ResourceGrid",
  components: {
    ResourceEmpty, ResourceMove
  },
  props: {
    parentId: Number,
    fileData: Array,
    categoryType: Number,
    queryParams: Object
  },
  data() {
    return {
      tableHeight: calcTableHeight(),
      fromPc: sessionStorage.getItem("fromPc"),
      menuVisible:false,
      dragImage:null,

      notifyMsgCache:{},
      backOptDuration:5000,
      moveForm: {
        folderId: 0,
        id:0,
        name:''
      },

      editCellId:-1,
      editCellParentId:0,
      editCellVal:'',
      editCellErrorTip:'', //文件名不能包含下列任何字符： / \\ ： * ？ < > |',
      editCellFocus:false,
      editCellToolTipVisible:false,
      editCellToolTipTimer:0,
      editCellRowItem:{id:0, name:''},
      editCellOldItem:{id:0, name:''},
      lastDeleteIds:[],

      currentRow:{},
      multipleSelectionIds:[],
      multipleSelectionCache: {},

      contextMenuItem:null,
      contextMenuItemIndex:0,
      // 菜单数据
      contextMenuData: {
        menuName: "grid",
        //菜单显示的位置
        axis: {
          x: null,
          y: null,
        },
        //菜单选项
        menulists: [
          {
            fnHandler: "downloadMenuHandler",
            btnName: "下载",
          }, {
            fnHandler: "moveMenuHandler",
            btnName: "移动到",
          }, {
            fnHandler: "renameMenuHandler",
            btnName: "重命名",
            disabled:false
          }, {
            fnHandler: "deleteMenuHandler",
            btnName: "删除",
          },
        ],
      }
    }
  },
  created() {
    window.resourceGridVue = this;
  },
  mounted() {
    let _this = this;
    window.addEventListener('resize', () => {
      _this.resizeTableHeight();
    });

    document.addEventListener('mouseup', function (e) {
      if (e.button === 0) {
        _this.onClickMenuOutside()
      }
    }, false)
  },
  methods: {
    quitViewMode() {
      try {
        if(this.editCellId !== -1) {
          this.cancelEditMode()
        }
      } catch (e) {
        console.error(e)
      }
    },
    toggleViewMode(viewType, multipleSelectionIds) {
      if(viewType !== 'grid') {
        return false;
      }
      this.resizeTableHeight()
      this.resetMultipleSelection(multipleSelectionIds, false)
      return true;
    },
    resetMultipleSelection(multipleSelectionIds, selectAll) {
      try {
        let selectionData = {};
        if(typeof (multipleSelectionIds) == "undefined" || multipleSelectionIds == null) {
          multipleSelectionIds = []
        }
        this.fileData.forEach(row => {
          if(selectAll || (multipleSelectionIds.length > 0 && (multipleSelectionIds.indexOf(row.id) != -1 || multipleSelectionIds.indexOf(''+row.id) != -1))) {
            this.$set(row, 'checked', true)
            selectionData[row.id] = row
            if(selectAll) {
              multipleSelectionIds.push(row.id)
            }
          } else {
            this.$set(row, 'checked', false)
          }
        });
        this.multipleSelectionCache = selectionData
        this.multipleSelectionIds = multipleSelectionIds
      } catch (e) {
        console.error(e)
      } finally {
        this.resetResEditModeType()
      }
    },
    resizeTableHeight() {
      this.tableHeight = calcTableHeight();
    },
    toggleSelectAll() {
      // console.log('toggleSelectAll', this.multipleSelectionIds, new Date())
      if(this.multipleSelectionIds.length == this.fileData.length && this.fileData.length > 0) {
        this.resetMultipleSelection([], false)
      } else {
        this.resetMultipleSelection([], true)
      }
    },
    toggleClickGrid(row) {
      try {
        // console.log('toggleClickGrid begin', row.id, 'row.checked', row.checked, new Date())
        this.currentRow = row;
        if(typeof (row.checked) == "undefined" || row.checked == false) {
          this.$set(row, 'checked', true)
          this.multipleSelectionCache[row.id] = row
        } else {
          this.$set(row, 'checked', false)
          if(row.id in this.multipleSelectionCache) {
            delete this.multipleSelectionCache[row.id]
          }
        }
        this.multipleSelectionIds =  Object.keys(this.multipleSelectionCache);
      } catch (e) {
        console.error(e)
      } finally {
        this.resetResEditModeType()
      }
    },
    resetResEditModeType() {
      let type = 0;
      try{
        type = (this.multipleSelectionIds.length > 1 ? 2 : (this.multipleSelectionIds.length == 1 ? 1 : 0));
      } catch (e) {
        console.error(e)
      } finally {
        // console.log('resetResEditModeType', type,  new Date())
        this.changeResEditModeType(type)
      }
    },
    getMultipleSelectionIds() {
      try{
        if(this.multipleSelectionIds != null) {
          return this.multipleSelectionIds;
        }
      } catch (e) {
        console.error(e, new Date())
      }
      return [];
    },
    multipleDownload() {
      let ids = this.getMultipleSelectionIds()
      if (ids.length == 0) {
        this.$message.error("请先选择文件");
        return;
      }
      this.download(ids)
    },
    multipleMove() {
      let ids = this.getMultipleSelectionIds()
      if (ids.length == 0) {
        this.$message.error("请先选择文件");
        return;
      }
      this.openResourceMoveDialog(ids);
    },
    multipleDelete() {
      let ids = this.getMultipleSelectionIds()
      if (ids.length == 0) {
        this.$message.error("请先选择文件");
        return;
      }
      this.confirmDel(ids)
    },
    changeResEditModeType(type) {
      this.$emit('changeResEditModeType', type)
    },
    refreshFiles(params) {
      this.multipleSelectionIds = []
      this.multipleSelectionCache = {}
      this.afterAddDir()
      this.$emit('refreshFiles', params)
    },
    uploadFiles(flag) {
      this.$emit('uploadFiles', flag)
    },
    download(ids, attachName) {
      this.$emit('download', ids, attachName)
    },
    previewFile(row){
      this.$emit('previewFile', row)
    },
    pcDownload(row) {
      this.download([row.id], row.isDir ? row.name + '.zip' : row.name + (row.suffix != null && row.suffix != '' ? ("." + row.suffix) : ''))
    },
    fetchFileImgUrl(row) {
      if(row.isDir == 1) {
        return '';
      }
      // 0 生成中  1有缩略图 2 无缩略图 3 生成失败
      if(row.thumbState == 1) {
        return row.thumPreviewUrl;
      }
      return (row.thumbState == 1) ? row.thumPreviewUrl : '';
    },
    generateRowImgStyle(row) {
      let imageUrl = this.fetchFileImgUrl(row);
      if(imageUrl != '') {
        return 'background-color: transparent;border:1px solid #D8DFE6;background-image:url("' + imageUrl + '")';
      }
      return '';
    },
    fmtFileIcon(row) {
      let icon = typeof (row.fileTypeIcon) != "undefined" ? row.fileIcon : (row.fileIcon = fetchFileTypeIcon(row.fileType, 'big'));
      if(icon != '') {
        return '<svg class="icon file-grid-item-icon" aria-hidden="true"><use xlink:href="#'+icon+'"></use></svg>';
      }
      return '';
    },
    fmtFileFullName(row) {
      if (typeof (row.fileFullName) != "undefined" && row.fileFullName != null) {
        return row.fileFullName;
      }
      row.fileFullName = fmtFileFullName(row);
      return row.fileFullName;
    },
    gotoDir(row) {
      if (row.isDir == 1 || row.fileType == 999) {
        return this.refreshFiles({parentId:row.id, 'name':row.name, 'path':row.path})
      }
      if (this.fromPc && this.fromPc == 1){
        this.pcDownload(row)
      }else {
        this.previewFile(row);
      }
    },
    onClickMenuOutside() {
      const menuType = document.getElementsByClassName('vue-contextmenuName-grid')[0].style.display
      if (menuType == 'block') {
        // console.log('onClickMenuOutside', menuType, new Date())
        this.changeGridPanelOverflowY('auto')
      }
    },
    showMenu(item, index) {
      if(this.fromPc && this.fromPc == 1) {
        return;
      }
      this.contextMenuItem = item
      this.contextMenuItemIndex = index
      event.preventDefault();
      let x = event.clientX;
      let y = event.clientY;

      let menuHeight = 152
      let bodyHeight = document.body.clientHeight;
      let offsetBottom = bodyHeight - (event.clientY + 12)
      if (offsetBottom < menuHeight) {
        y = y - menuHeight
      }
      // Get the current location
      this.contextMenuData.axis = {
        x,
        y
      };
      this.changeGridPanelOverflowY('hidden')
      if(typeof (item.checked) == "undefined" || item.checked == false) {
        this.resetMultipleSelection([item.id], false)
        this.contextMenuData.menulists[2].disabled = false
      } else {
        let ids = this.getMultipleSelectionIds()
        console.log('ids.length', ids.length, new Date())
        this.contextMenuData.menulists[2].disabled = ids.length > 1
      }
    },
    changeGridPanelOverflowY(overflowY) {
      try {
        let panelEle = document.getElementsByClassName('file-grid-panel')
        if(panelEle != null && panelEle.length > 0) {
          panelEle[0].style.overflowY = overflowY;
        }
      } catch (e) {
        console.error(e)
      }
    },
    openResourceMoveDialog(ids) {
      // console.log('openResourceMoveDialog', this.parentId, 'ids', ids, new Date())
      this.$refs.resourceMove.multipleMove(this.parentId, ids);
    },
    closeAllNotify() {
      try{
        for (let notifyId in this.notifyMsgCache) {
          this.notifyMsgCache[notifyId].close();
        }
      } catch (e) {
        console.log(e, new Date())
      }
    },
    confirmDel(ids) {
      this.$confirm("确定要删除文件/文件夹？","确认删除").then(() => {
        // console.log('confirmDel', ids, new Date());
        this.deleteFiles(ids)
      });
    },
    deleteFiles(ids) {
      if (typeof (ids) == "undefined" || ids == null || ids.length == 0) {
        return;
      }
      this.ucloading.showLoading();
      this.lastDeleteIds = ids;
      let params = {ids:ids.join(',')};
      this.$api.post("/resapi/tw/resource-file/deleteFiles",params).then(res => {
        if (!res.success) {
          this.$message.error(res.info);
          this.refreshFiles();
          return;
        }
        const delCnt = typeof (res.data) != "undefined" ? res.data : 0;
        const msgTxt = delCnt > 1 ? '恭喜你，' + delCnt + '个文件删除成功' : '恭喜你，文件删除成功'
        const h = this.$createElement;
        const notifyId = 'notification-delete-back_' + new Date().getTime();
        let notify = this.$messageZ.success({
          title: '提示',
          message: h("p", null, [
                h("span", null, msgTxt),
                h("a", {class: "notification-view-detail notification-edit-back", on: {click: this.deleteBack}}, "撤回删除"),
              ]
          ),
          duration: this.backOptDuration,
        });
        this.notifyMsgCache[notifyId] = notify;
        this.refreshFiles();
      }).finally(() => {
        this.ucloading.hideLoading();
      })
    },
    deleteBack() {
      let ids = this.lastDeleteIds || [];
      if (typeof (ids) == "undefined" || ids == null || ids.length == 0) {
        return;
      }
      this.closeAllNotify()
      this.ucloading.showLoading();
      let params = {ids:ids.join(',')};
      this.$api.post("/resapi/tw/resource-file/deleteBack",params).then(res => {
        if (!res.success) {
          this.$message.error(res.info);
          this.refreshFiles();
          return;
        }
        // console.log(res, new Date());
        this.$message.success('撤回成功');
        this.refreshFiles();
      }).finally(() => {
        this.ucloading.hideLoading();
      })
    },
    downloadMenuHandler() {
      // console.log("downloadMenuHandler", this.contextMenuItem.id, new Date());
      this.multipleDownload()
    },
    moveMenuHandler() {
      // console.log("moveMenuHandler 111", this.contextMenuItem.id,  new Date());
      this.multipleMove()
    },
    renameMenuHandler() {
      console.log("renameMenuHandler", this.contextMenuItem.id, new Date());
      let row = this.contextMenuItem;
      let editCellId = this.fetchRowKey(row, this.contextMenuItemIndex);
      this.enterEditNameMode(row, editCellId,false);
    },
    deleteMenuHandler() {
      // console.log("deleteMenuHandler", this.contextMenuItem.id, new Date());
      this.multipleDelete()
    },
    afterQueryFiles() {
      try {
        this.afterAddDir()
        if(this.multipleSelectionIds.length > 0) {
          this.multipleSelectionIds = []
          this.multipleSelectionCache = {};
        }
        if(this.categoryType == 0) {
          this.rowDrop()
        }
      } catch (e) {
        console.error(e)
      } finally {
        this.resetResEditModeType()
      }
    },
    // 行拖拽
    // 行拖拽
    rowDrop() {
      const _this = this
      // 被拖动的元素的索引
      let dragged = null;
      // 被拖动的元素的索引
      let draggedIndex = -1;

      // 被拖动的元素正在那个容器里
      let dragIndex = -1

      let loop = null

      // 目标元素
      let target = document.querySelector('.file-grid-panel');
      let rows = 0;//行数
      setTimeout(function () {
        rows = target.childElementCount
        for (let i = 0; i < target.childElementCount; i++) {
          const child = target.children[i]
          child.draggable = true
          // child.style.cursor = 'copy'
          child.ondragstart = function (e) {
            if (e.path){
              dragged = e.path[0];
            } else {
              dragged = e.composedPath()[0];
            }
            draggedIndex = parseInt(dragged.getAttribute('rowIndex'))
            console.log('resGrid  child' + i + '开始拖拽', e.target, new Date());
            _this.cellMouseIndex = -1
            dragged.style.cursor = 'grabbing'

            let dragingBox = document.getElementById("dragBox").cloneNode(true);
            dragingBox.style.display = "inline-block";
            dragingBox.id = "dragingBox";
            dragingBox.style.position = "absolute";
            dragingBox.style.top = "0px";
            dragingBox.style.right = "0px";
            dragingBox.style.zIndex = "-1";
            if (_this.multipleSelectionIds.length > 1){
              dragingBox.innerHTML = "移动" + _this.multipleSelectionIds.length + "文件到";
            }else {
              dragingBox.innerHTML = "移动到";
            }
            document.body.appendChild(dragingBox);
            e.dataTransfer.setDragImage(dragingBox, 0, 0);
          }
          child.ondragend = function () {
            console.log('child' + i + '拖拽结束');
            document.body.removeChild(document.getElementById("dragingBox"));
            if (dragIndex > -1) {
              clearClassForLast()
            }
          }
        }
      }, 0)

      target.ondragenter = function (e) {
        let path;
        if (e.path){
          path = e.path;
        }else {
          path = e.composedPath();
        }
        // 由于被拖动的元素 经过tbody中的每一元素都会触发该事件, 但是我们只需要它正在那一行上就行了
       //  console.log('resGrid ondragenter', path[0].className, new Date());
        clearLoopTimeout(loop)
        if (path[0].tagName === 'DIV') {
          // throughRow 表示被拖动的元素正在哪一行上
          const throughRow = path.find(function(tmpPath) {
            // console.log('ondragenter tmpPath', tmpPath, new Date())
            if (typeof (tmpPath.className) != "undefined" && tmpPath.className != null) {
              if (tmpPath.className == 'file-grid-item' || tmpPath.className.indexOf('file-grid-item ') != -1) {
                return tmpPath
              }
            }
          })
          if (typeof (throughRow) != "undefined" && throughRow != null) {
            let throughRowIndex = parseInt(throughRow.getAttribute('rowIndex'))
            if (dragIndex !== throughRowIndex) {
              if (dragIndex > -1) {
                // 清除上次进入的容器的状态
                clearClassForLast()
              }
              console.log('resGrid 拖动进入目标元素 ' + throughRowIndex, new Date());
              // 不是自己或未文件夹时才改变状态
              if (typeof(dragged) != "undefined" && dragged != null && draggedIndex !== throughRowIndex && _this.fileData[throughRowIndex].isDir == 1) {
                // 改变本次进入的容器的状态
                dragged.style.cursor = 'copy'
                // throughRow.style.height = 60 + 'px'
                throughRow.style.backgroundColor = '#E6EDF5'
              }
              dragIndex = throughRowIndex
            }
          }
        }
        leaveIndex = -1
      }

      target.ondragover = function (e) {
        console.log('resGrid 目标元素中拖拽...');
        e.preventDefault();
        leaveIndex = -1
        let path;
        if (e.path){
          path = e.path;
        }else {
          path = e.composedPath();
        }
        // console.log('resGrid ondragover', path[0].className, path[0].tagName, new Date());
        if (typeof (path) != "undefined" && path[0].tagName === 'DIV' && path[0].className === 'file-grid-panel') {
          clearClassForLast()
          dragIndex = -1
        }
      }

      let leaveIndex = -1 // 是否拖出了整个table, -1表示还在table内
      target.ondragleave = function (e) {
        let path;
        if (e.path){
          path = e.path;
        }else {
          path = e.composedPath();
        }
        // console.log('resGrid ondragleave', path[0].className, path[0].tagName, new Date());
        clearLoopTimeout(loop)
        if (path[0].tagName === 'DIV' || path[0].tagName === 'SPAN') {
          const throughRow = path.find(function(tmpPath) {
            if (typeof (tmpPath.className) != "undefined" && tmpPath.className != null) {
              if (tmpPath.className == 'file-grid-item' || tmpPath.className.indexOf('file-grid-item ') != -1) {
                return tmpPath
              }
            }
          })
          if (typeof (throughRow) != "undefined" && throughRow != null) {
            let throughRowIndex = parseInt(throughRow.getAttribute('rowIndex'))
            // console.log('resGrid 拖动离开目标元素 ' + throughRowIndex, (throughRowIndex == dragIndex),' dragIndex', dragIndex, new Date());
            if (throughRowIndex == dragIndex) {
                leaveIndex = throughRowIndex
                loop = setTimeout(function () {
                  if (leaveIndex > -1) {
                    console.log("resGrid 离开了", leaveIndex)
                    const leave = target.children[leaveIndex];
                    clearClass(leave)
                    dragIndex = -1
                  }
                }, 100)
                // console.log('resGrid 拖动离开目标元素 ' + throughRowIndex, ' start loop', loop, ' leaveIndex=', leaveIndex);
              }

          }
        }
      }
      target.ondrop = function () {
        console.log('resGrid 放下了' + draggedIndex, ' dragIndex=', dragIndex, new Date());
        // 清除上次进入的容器的状态
        const last = target.children[dragIndex];
        clearClass(last)
        dragged.style.cursor = 'default'
        const from = _this.fileData[draggedIndex]
        const to = _this.fileData[dragIndex]
        if (typeof (last) != "undefined" && last != null && (from.id != to.id) && (to.isDir == 1)) {
          // 移动文件/文件夹
          // console.log('resGrid 放下了'+draggedIndex, 'last', last, from, to, new Date());
          _this.copyOrMoveApi(from, to)
        }
      }

      let clearClass = function (node) {
        if (node) {
          node.style = {}
        }
        if (typeof (dragged) != "undefined" && dragged != null) {
          dragged.style.cursor = 'grabbing'
        }
      }

      let clearClassForLast = function () {
        // 清除上次进入的容器的状态
        if (dragIndex > -1) {
          const last = target.children[dragIndex];
          if(typeof(last) != "undefined" && last != null) {
            clearClass(last)
          }
        }
      }

      let clearLoopTimeout = function() {
        // console.log('clearLoopTimeout loop', loop)
        if (loop != null) {
          clearTimeout(loop)
        }
      }

    },
    copyOrMoveApi(from, to) {
      let ids = [from.id];
      let fromId = '' + from.id;
      let selectIds = this.getMultipleSelectionIds()
      if (selectIds.length > 0 && (selectIds.indexOf(fromId) !== -1 || selectIds.indexOf(from.id) !== -1)) {
        ids = selectIds
      }
      console.log('resTable copyOrMoveApi', from.id, to.id, new Date())
      // console.log('resTable copyOrMoveApi', from.id, to.id, 'selectIds', selectIds, ', ids=', ids, new Date())
      this.$refs.resourceMove.outerMoveCheck(to.id, ids);
    },
    enterAddDir(parentId) {
      // console.log('table enterAddDir methods', parentId, new Date())
      if (this.editCellId !== -1) {
        let editCellItem = this.fetchFileItemById(this.editCellId);
        if (editCellItem != null) {
          this.changeResEditModeType(0)
          return;
        }
        this.afterAddDir();
      }
      this.ucloading.showLoading();
      let params = {parentId:parentId, name: '新建文件夹'};
      this.$api.post("/resapi/tw/resource-file/addDir", params).then(res => {
        this.ucloading.hideLoading();
        if (!res.success) {
          this.$message.error(res.info);
          return;
        }
        // this.$message.success('创建文件夹成功');
        if(res.data) {
          let row = res.data;
          row.isNew = true;
          row.lastModifiedDate = new Date().getTime()
          this.fileData.unshift(row);
          this.enterEditNameMode(row, row.id, true)

          if(this.categoryType == 0) {
            this.rowDrop()
          }
        }
      }).catch(error => {
        console.error(error);
        this.ucloading.hideLoading();
        this.afterAddDir();
      })
    },
    enterEditNameMode(row, editCellId, forAddDir) {
      this.editCellId = editCellId;
      if (editCellId != -1) {
        this.editCellRowItem = row;
        this.editCellVal = row.name;
        this.editCellOldItem = {id:row.id, name:row.name}
        this.delayFocusEditCell(editCellId, forAddDir)
        this.closeAllNotify()
        this.changeResEditModeType(1)
      }
    },
    delayFocusEditCell(editCellId, forAddDir) {
      if(typeof (editCellId) == "undefined" || editCellId == null) {
        editCellId = this.editCellId
      }
      if(typeof (forAddDir) == "undefined" || forAddDir == null) {
        forAddDir = false
      }
      if (editCellId == -1) { return; }
      this.$nextTick(function () {
        try {
          let refName = 'editGridCell'+editCellId;
          this.forceFocusEditCell(refName, true)
          if(forAddDir) {
            document.getElementsByClassName('el-table__body-wrapper ')[0].scrollTop = 0
          }
        } catch (e) {
          console.error(e)
        }
      });
    },
    forceFocusEditCell(refName, selectFlag) {
      try {
        if(typeof (refName) == "undefined" || refName == null) {
          refName = 'editGridCell'+this.editCellId;
        }
        if(typeof (selectFlag) == "undefined" || selectFlag == null) {
          selectFlag = false
        }
        // console.log('forceFocusEditCell', refName, this.$refs[refName], new Date())
        let inputElem = this.$refs[refName]
        if(typeof (inputElem) != "undefined" && inputElem != null && inputElem.length > 0) {
          if (typeof(inputElem[0].focus) != "undefined") {
            if (selectFlag) {
              inputElem[0].select();
            }
            inputElem[0].focus();
          }
        }
      } catch (e) {
        console.error(e)
      }
      return true;
    },
    fetchRowKey(row, index) {
      if(typeof (row.id) != 'undefined' && row.id != 0) {
        return row.id;
      }
      return index;
    },
    handleCellInput(e) {
      // console.log('handleCellInput e.data=', e.data, 'selectionStart', e.target.selectionStart, 'selectionEnd',  e.target.selectionEnd, ' editCellVal = ', this.editCellVal, new Date())
      this.editCellFocus = true
      if(typeof (e) != "undefined" && typeof (e.data) != "undefined" && e.data != '') {
        const selectionStart =  typeof (e.target) != "undefined" ? e.target.selectionStart : -1;
        const selectionEnd = typeof (e.target) != "undefined" ? e.target.selectionEnd : -1;
        if(!this.validateFileName(e.data)) {
          this.editCellVal = fmtInvalidFileName(this.editCellVal.trim())
          this.delayHideCellErrorTip()
          this.$nextTick(function() {
            if(typeof (selectionStart) != "undefined" && selectionStart > 0) {
              e.target.selectionStart = selectionStart - 1
              e.target.selectionEnd = selectionEnd - 1
            }
          })
        }
      }
    },
    delayHideCellErrorTip() {
      if(this.editCellToolTipTimer) {
        window.clearTimeout(this.editCellToolTipTimer)
      }
      let vm = this;
      this.editCellToolTipTimer  = setTimeout(function () {
        vm.validateFileName(vm.editCellVal)
        // console.log('editCellErrorTip', vm.editCellErrorTip, new Date())
      }, 3000)
    },
    handleCellInputKeyDown(e, index, row) {
      if (e.which == 13) {
        // console.log('handleCellInputKeyDown', e.key, e.which , ' row.id =', row.id, ' rowIndex =', index, new Date())
        this.handleCellInputEvent(e, index, row)
      }
    },
    handleCellInputFocus(e) {
      // console.log('handleCellInputFocus', e.data, new Date())
      this.editCellFocus = true
      this.editCellToolTipVisible =  this.editCellFocus && this.editCellErrorTip != ''
      e.currentTarget.select()
    },
    handleCellInputBlur(e, index, row) {
      this.editCellFocus = false
      this.editCellToolTipVisible = false
      this.handleCellInputEvent(e, index, row)
    },
    validateCancelEditModeEvent(event) {
      try{
        if (typeof (event.relatedTarget) != "undefined" && event.relatedTarget != null) {
          if (typeof (event.relatedTarget.className) != "undefined" && event.relatedTarget.nodeName == 'BUTTON') {
            const _className = event.relatedTarget.className
            if (_className != null && _className.indexOf('custom-icon-button') != -1) {
              return true;
            }
          }
        }
      } catch (e) {
        console.error(e, new Date())
      }
      return false;
    },
    handleCellInputEvent(event, index, row, doSubmit) {
      try {
        if(typeof (doSubmit) == "undefined") {
          doSubmit = true;
        }
        if (typeof (row.id) != 'undefined' && row.id != this.editCellId) {
          return;
        }
        let refName = 'editGridCell'+ this.fetchRowKey(row, index);
        if(this.validateCancelEditModeEvent(event)) {
          return;
        }
        //  console.log('handleCellInputBlur',event , index, row,  refName, this.editCellVal, new Date())
        this.editCellVal = this.editCellVal.trim()
        if(this.editCellVal.length == 0) {
          if(doSubmit) {
            this.$message.error(row.isDir == 1 ? '文件夹名称不能为空' : '文件名称不能为空');
            this.editCellVal =  this.editCellOldItem.name
            this.forceFocusEditCell(refName)
          }
          return;
        }
        if(!this.validateFileName(this.editCellVal)) {
          // this.forceFocusEditCell(refName)
          return;
        }

        if (doSubmit) {
          try {
            if (typeof (row.id) != 'undefined') {
              if(row.id > 0) {
                this.editName(row.id, this.editCellVal, row);
              }
            }
            // row.name = this.editCellVal;
          } catch(t1) {
            console.error(t1, new Date())
          }
        }
      } finally {
        this.editCellToolTipVisible =  this.editCellFocus && this.editCellErrorTip != ''
      }
    },
    afterAddDir() {
      // console.log('afterAddDir', new Date())
      this.addDirOptItem = {id:0, st:0}
      this.quitEditCellMode()
    },
    cancelEditMode() {
      // console.log('cancelEidtMode', new Date())
      this.addDirOptItem = {id:0, st:0}
      this.quitEditCellMode()
      this.refreshFiles()
    },
    quitEditCellMode(){
      try {
        this.editCellId = -1;
        this.editCellVal='';
        this.editCellErrorTip='';
        // this.editCellRowItem={id:0, name:''};
        this.resetResEditModeType()
      } catch (e) {
        console.error(e, new Date())
      }
    },
    validateFileName(name) {
      let errorTip = '';
      try {
        if (name != null && name.length > 0) {
          if(!validateFileName(name)) {
            errorTip = '文件名不能包含下列任何字符：/ \\ ： * ？" < > |'
          } else if( name.length > 198) {
            errorTip = "字符上限最大支持≤198";
          }
        }
      } catch(t) {
        console.error(t, new Date())
      } finally {
        this.editCellErrorTip = errorTip;
      }
      return errorTip == '';
    },
    editName(id, name, row) {
      let params = {id:id,name:name};
      this.$api.post("/resapi/tw/resource-file/editName",params).then(res => {
        if (res.success) {
          // console.log(res, this.editCellRowItem.id, this.editCellRowItem.name, name, new Date());
          this.editCellId = -1;
          if(this.editCellRowItem.id == id && this.editCellRowItem.name != name) {
            this.editCellRowItem.name = name
            const h = this.$createElement;
            const notifyId = 'notification-edit-back_' + new Date().getTime();
            const notity = this.$messageZ.success({
              title: '提示',
              message: h("p", null, [
                    h("span", null, '恭喜你，文件重命名成功'),
                    h("a", {class: "notification-view-detail notification-edit-back", on: {click: this.editNameBack}}, "撤回"),
                  ]
              ),
              duration: this.backOptDuration
            });
            this.notifyMsgCache[notifyId] = notity;
            this.resetResEditModeType()
            this.refreshFiles()
          } else {
            if(typeof (row) != "undefined" && row.isNew) {
              row.isNew = false
              this.$message.success('创建文件夹成功');
              this.resetRowLastModifiedDate(row)
            }
            this.quitEditCellMode()
          }
        } else {
          this.$message.error(res.info);
          if(res.info == "文件名称重复") {
            this.editCellVal =  this.editCellOldItem.name
          }
          this.forceFocusEditCell()
        }
      }).catch(error => {
        console.error(error);
        this.quitEditCellMode()
      })
    },
    editNameBack() {
      let id =  this.editCellOldItem.id;
      let name = this.editCellOldItem.name;
      // console.log('editNameBack',id, name, new Date())
      let params = {'id':id, 'name':name}
      this.closeAllNotify();
      this.$api.post("/resapi/tw/resource-file/editName", params).then(res => {
        try {
          if (res.success) {
            this.$message.success('撤回成功');
            if(this.editCellRowItem.id == id && this.editCellRowItem.name != name) {
              this.editCellRowItem.name = name
            }
            this.refreshFiles();
          } else {
            this.$message.error(res.info);
            this.refreshFiles();
          }
        } catch (t) {
          console.error(t, new Date())
        }
      })
    },
    fetchPerRowNumber() {
      try {
        let offsetTop = null
        let items = document.querySelectorAll('.file-grid-panel .file-grid-item');
        for(let i = 0;i<items.length;i++) {
          let item = items[i]
          if(offsetTop == null) {
            offsetTop = item.offsetTop
          } else if(offsetTop != item.offsetTop) {
            return i;
          }
        }
      } catch (e) {
        console.error(e)
      }
      return 0;
    },
  }
}
</script>

<style>
.file-grid-top-panel {
  color: #303233;
  font-size: 14px;
  line-height: 40px;
  height: 40px;
  border-bottom: 0px solid #F0F2F5;
}
.file-grid-panel {
  overflow-y: auto;
}
.file-grid-item {
  width: 176px;
  height: 176px;
  border-radius: 6px;
  background-color: transparent;
  border: 2px solid transparent;
  text-align: left;
  display: block;
  float: left;
  margin: 18px 0 0 15px;
}
.file-grid-item-inner {
  text-align: center;
}
.file-grid-item-img {
  width: 118px;
  height: 104px;
  background-color: transparent;
  margin: 27px auto 0 auto;
  background-repeat: no-repeat;
  background-position: center;
  background-size: cover;
  border-radius: 6px;
}
.file-grid-item-icon-panel {
  line-height:104px;
  display: block;
}
.file-grid-item-icon-panel.normal  {
  background-color: transparent;
  border-radius: 6px;
}
.file-grid-item-icon-panel.normal svg {
  width: 80px;
  height: 80px;
  vertical-align: middle;
  margin-left: 0 !important;
  margin-right: 0 !important;
}
.file-grid-item-icon-panel.tag {
  background-color: transparent;
  text-align: right;
}
.file-grid-item-icon-panel.tag svg {
  width: 26px;
  height: 30px;
  vertical-align: bottom;
  margin-bottom: -3px;
  margin-right: -6px;
}
.file-grid-item-img.folder {
  background-color: transparent;
  background-size: contain;
  background-image: url("../../assets/resource-content/folder.svg");
  width: 86px;
  height: 100px;
}
.file-grid-item:hover {
  cursor: pointer;
  background-color: #F5F7FA;
}
.file-grid-item.selected {
  border: 2px solid #20CCC6;
}
.file-grid-item:hover .file-grid-item-img {
  background-color: transparent;
}
.file-grid-item-label {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  max-width: 90%;
  color: #303233;
  font-size: 14px;
  margin: 8px auto 0 auto;
  line-height: 20px;
}

.vue-contextmenu-listWrapper {
  font-family: inherit !important;
  color: #606366 !important;
  border: 1px solid #DFE6ED;
}
.context-menu-list:hover {
  background-color: #E6EDF5  !important;
}
.context-menu-list .btn-wrapper-simple {
  height: 24px  !important;
  line-height: 24px  !important;
}
.nav-name-right {
  margin-left: 5px !important;
  line-height: 24px  !important;
}

.file-grid-item .el-radio__input {
  float: left;
  padding-top: 10px;
  padding-left: 12px;
  visibility: hidden;
  display: none;
}
.file-grid-item:hover .el-radio__input, .file-grid-item .el-radio__input.is-checked {
  visibility: visible;
  display: inline-block;
}

.file-grid-item .edit-cell {
  width: 152px;
  height: 21px;
  margin-top: 6px;
  outline-color: #73B6F0;
  text-align: center;
}

#dragBox, #dragingBox {
  border: 1px solid #E6EDF5;
  border-radius: 5px;
  width: auto;
  height: 45px;
  line-height: 45px;
  z-index: 2;
  color: #20CCC6;
  padding: 0 20px;
  font-size: 14px;
  background-color: rgba(255,255,255,0.9);
  font-weight: 400;
}
</style>